import React from "react";
import { useSelector } from "react-redux";
import FLMultiSelect from "./filters/FLMultiSelect";
import FLSingleSelect from "./filters/FLSingleSelect";
import FLBrandModelCascade from "./filters/FLBrandModelCascade";
import FLKmInput from "./filters/FLKmInput";
import FLYearInput from "./filters/FLYearInput";
import FLBuyerKmMax from "./filters/FLBuyerKmMax";
import FLBuyerYearRange from "./filters/FLBuyerYearRange";
import FLM2Input from "./filters/FLM2Input";
import FLBuyerM2Range from "./filters/FLBuyerM2Range";
import FLKatSayisiInput from "./filters/FLKatSayisiInput";
import FLBuyerKatSayisiRange from "./filters/FLBuyerKatSayisiRange";
import FLBulunduguKatSelect from "./filters/FLBulunduguKatSelect";
import FLBuyerBulunduguKatRange from "./filters/FLBuyerBulunduguKatRange";

// CREATE flow renders category filters. Search-only filter types (minMaxKm,
// minMaxFiyat, minMaxYear) are intentionally not mapped here — they belong to
// FilterCategory. yearInput/kmInput are kind-aware: seller writes a single
// value, buyer writes a range (or single max) following the price/priceMin
// /priceMax convention.
function CreateAdvertFilters(props) {
  const kind = useSelector((state) => state.advert.newAdvert.kind) || "buyer";

  return (
    <div className="d-flex flex-column ">
      {props.filters.map(
        (filter) =>
          ({
            multiSelect: <FLMultiSelect filter={filter} key={filter.id} />,
            singleSelect: <FLSingleSelect filter={filter} key={filter.id} />,
            multiCheck: <FLMultiSelect filter={filter} key={filter.id} />,
            brandModelCascade: <FLBrandModelCascade filter={filter} key={filter.id} />,
            kmInput:
              kind === "seller" ? (
                <FLKmInput filter={filter} key={filter.id} />
              ) : (
                <FLBuyerKmMax filter={filter} key={filter.id} />
              ),
            yearInput:
              kind === "seller" ? (
                <FLYearInput filter={filter} key={filter.id} />
              ) : (
                <FLBuyerYearRange filter={filter} key={filter.id} />
              ),
            m2Input:
              kind === "seller" ? (
                <FLM2Input filter={filter} key={filter.id} />
              ) : (
                <FLBuyerM2Range filter={filter} key={filter.id} />
              ),
            katSayisiInput:
              kind === "seller" ? (
                <FLKatSayisiInput filter={filter} key={filter.id} />
              ) : (
                <FLBuyerKatSayisiRange filter={filter} key={filter.id} />
              ),
            bulunduguKatInput:
              kind === "seller" ? (
                <FLBulunduguKatSelect filter={filter} key={filter.id} />
              ) : (
                <FLBuyerBulunduguKatRange filter={filter} key={filter.id} />
              ),
          }[filter.filterType])
      )}
    </div>
  );
}

export default CreateAdvertFilters;
